/* import { httpClient } from './http-client';
import { INVOICE_ENDPOINTS } from '@/config/api'; */
import { BaseApi } from './base-api';
import type { ExtendedListParams } from '../types/search-criteria';
import type {
  Invoice,
  InvoicesList,
} from '../types/invoice';
import { removeNulls, unique} from './utils';
import { SearchCriteriaBuilder } from './search-criteria';
import { INVOICE_ENDPOINTS } from '@/config/api';

export class InvoiceApi extends BaseApi {
  /**
   * Получить список инвойсов с фильтрацией и пагинацией
   */
  static async getInvoices(params?: ExtendedListParams): Promise<InvoicesList> {
    return this.getList<Invoice>(INVOICE_ENDPOINTS.INVOICES, params);
  }

  /**
   * Получить инвойс по ID
   */
  static async getInvoiceById(invoiceId: number): Promise<Invoice> {
    return this.getById<Invoice>(INVOICE_ENDPOINTS.INVOICE_BY_ID(invoiceId));
  }

  // ============ Методы с критериями поиска ============

  /**
   * Поиск инвойсов по тексту в нескольких полях
   */
  static async searchInvoices(searchText: string, additionalParams?: Omit<ExtendedListParams, 'criteria'>): Promise<InvoicesList> {
    const params = this.createTextSearchParams(searchText, additionalParams, ['name', 'body']);
    return this.getInvoices(params);
  }

  static async getInvoicesByIds(ids: number[], additionalParams?: Omit<ExtendedListParams, 'criteria'>): Promise<InvoicesList> {
    const filteredIds = removeNulls(unique(ids));
    if(filteredIds.length === 0) {
      return {
        items: [],
        total: 0,
      };
    }
    const params = this.createIdSearchParams(filteredIds, additionalParams, 'id');
    return this.getInvoices(params);
  }

  static async getInvoicesByContractId(contractId: number, additionalParams?: Omit<ExtendedListParams, 'criteria'>): Promise<InvoicesList> {
    const params = (additionalParams?: Omit<ExtendedListParams, 'criteria'>) => {
      const criteria = SearchCriteriaBuilder
        .create('and')
        .addCondition('entityId', 'eq', contractId)
        .addCondition('entityType', 'eq', ['rent', 'rent_fee'])
        .build();

      return {
        ...additionalParams,
        criteria
      };
    }
    return this.getInvoices(params(additionalParams));
  }
}
